module.exports = __webpack_public_path__ + "img/nosermons.49324a5f.png";